import axios from "axios";

export const getRealTimeDataAPI = async (device_id, type, take, min) => {
  let response = await axios({
    url: `/api/v2/device/realtime-monitor/operationDetail`,
    method: "GET",
    params: {
      device_id: device_id,
      type: type,
      take: take,
      min: min
    }
  });
  if (response.data && response.data.data) {
    return response.data.data;
  }
  return [];
};
